// Industry and Domain data for ORB Uplift

export const INDUSTRIES = [
  'Health',
  'Public Affairs',
  'Business',
  'Banking',
  'Real Estate',
  'Technology',
  'Construction',
  'Automotive',
  'Telecommunications',
  'Transportation',
  'Arts',
  'Entertainment',
  'Insurance',
  'Education',
  'Agriculture',
  'Hospitality'
];

export const INDUSTRY_DOMAINS = {
  'Health': ['Care', 'Quality', 'Access', 'Nutrition', 'Pharmaceuticals'],
  'Public Affairs': ['Government', 'Non-Profits', 'Think Tanks', 'Legislatures'],
  'Business': ['Sales', 'Marketing', 'HR', 'Operations', 'Finance'],
  'Banking': ['Investments', 'Retail', 'Commercial', 'Advisors', 'Private Equity', 'Accounting'],
  'Real Estate': ['Residential', 'Commercial', 'Appraisals'],
  'Technology': ['Cyber', 'Software', 'Bio', 'AI', 'Education'],
  'Construction': ['Residential', 'Commercial', 'Civil'],
  'Automotive': ['Manufacturing', 'Sales', 'Financial'],
  'Telecommunications': ['Radio', 'TV', 'ISP', 'Voice', 'Data', 'Cloud', 'Wireless', 'Telecom'],
  'Transportation': ['Aviation', 'Truck', 'Rail', 'Maritime'],
  'Arts': ['Architecture', 'Music', 'Ads', 'Design', 'Fashion', 'Publishing'],
  'Entertainment': ['Performing', 'Film', 'Audio Production', 'Animation'],
  'Insurance': ['Health', 'Mortgage', 'Auto', 'Life', 'Travel', 'Liability', 'Disability'],
  'Education': ['K-12', 'Colleges', 'Universities', 'Vocational', 'Tutoring', 'Testing Services'],
  'Agriculture': ['Production', 'Forestry', 'Animal Husbandry', 'Soil Sciences'],
  'Hospitality': ['Tourism', 'Recreation', 'Casinos', 'Hotels', 'Travel Agencies']
};

export const US_STATES = [
  'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California',
  'Colorado', 'Connecticut', 'Delaware', 'Florida', 'Georgia',
  'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa',
  'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland',
  'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri',
  'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey',
  'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio',
  'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina',
  'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont',
  'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'
];

export const ROLES = ['supervisor', 'lead', 'affiliate'];

// Leadership Interview booking links by role
export const LEADERSHIP_INTERVIEW_LINKS = {
  'supervisor': 'https://outlook.office.com/book/CollectiveSolutionsInc2@collectiveorb.com/s/F-o83vSNyU6OTiqDdQWBXQ2?ismsaljsauthenabled',
  'lead': 'https://outlook.office.com/book/CollectiveSolutionsInc2@collectiveorb.com/s/n-fmKfU4ZEuMu6ELu_ZEfg2?ismsaljsauthenabled',
  'affiliate': 'https://outlook.office.com/book/CollectiveSolutionsInc2@collectiveorb.com/s/uxoHlE1QmkSUlULMPnwQQw2?ismsaljsauthenabled'
};
